export default __webpack_public_path__ + "static/media/u_wdt_c_4.2a45c659.mp3";